import { AccordionDetails, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikErrors, FormikHandlers, FormikState } from 'formik';
import { AccountData } from '../../../api';
import { useLanguage } from '../../../common/GeneralUtils';
import { OrderPagesMultiSelect } from '../../../userSettings/OrderPagesMultiSelect';
import { Accordion, AccordionSummary } from '../../../calendar/dialogs/EditOrderDialog/components/Accordion';
import { StorefrontPanels } from '../StorefrontDrawer';

type FormWithOrderPageIds = {
  order_page_ids: string[];
};

type OrderPagesPanelProps = {
  account: AccountData;
  values: FormWithOrderPageIds;
  errors: FormikErrors<FormWithOrderPageIds>;
  touched: FormikState<FormWithOrderPageIds>['touched'];
  handleChange: FormikHandlers['handleChange'];
  setFieldValue: (field: string, value: any) => void;
  expanded?: StorefrontPanels;
  onPanelChange: (panel: StorefrontPanels) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  panelName: StorefrontPanels;
};

export const OrderPagesPanel = ({
  account,
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  expanded,
  onPanelChange,
  panelName,
}: OrderPagesPanelProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const activityLabel = account?.activity_label_plural?.[language];
  const activityLabelSingular = account?.activity_label_singular?.[language];

  return (
    <Accordion expandedPanelName={expanded} panelName={panelName} onChange={onPanelChange}>
      <AccordionSummary
        title={activityLabel || t('storefronts.order_pages')}
        summaryComponent={<Typography variant="body2">{values.order_page_ids?.length || 0}</Typography>}
      />
      <AccordionDetails>
        <Grid container flexDirection="column" gap={1}>
          <Typography variant="body2" color="text.secondary">
            {t('storefronts.drag_to_reorder', { activity: activityLabelSingular || t('storefronts.order_page') })}
          </Typography>

          <OrderPagesMultiSelect
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            orderPagesFieldName="order_page_ids"
            account={account}
            orderable
            setFieldValue={setFieldValue}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
